// app/routes/media/index.tsx
import { Link, Outlet } from "@remix-run/react";
import { Footer } from "~/components/footer";
import { Header } from "~/components/header";

export default function MediaIndexPage() {
	const articles = [
		{
			slug: "youtube-shorts-howto",
			thumbnail_url: "/youtube-shorts-howto.png",
			title: "個人勢Vtuberが知っておくべきYouTube Shorts作成方法",
			description:
				"個人勢VtuberがYouTube Shortsを活用し、視聴者エンゲージメントを高める方法を解説",
		},
	];

	return (
		<div className="flex flex-col min-h-screen">
			<Header />
			<main className="flex-1 container mx-auto px-4 py-12">
				<h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-center mb-12">
					記事一覧
				</h1>
				<p className="text-center mb-8 text-gray-700">
					コラムを通して、Vtuber・ストリーマー運営を効率化・改善するヒントを提供します。
				</p>
				<div className="grid gap-6 md:grid-cols-3">
					{articles.map((article) => (
						<Link
							to={`/column/${article.slug}`}
							key={article.slug}
							className="block"
						>
							<div className="h-full hover:shadow-lg transition-shadow p-2">
								{article.thumbnail_url && (
									<img
										src={article.thumbnail_url}
										alt={article.title}
										className="w-3/4 h-auto rounded-t-md object-cover mx-auto mb-2"
									/>
								)}
								<div className="w-3/4 mx-auto">
									<h2 className="text-lg font-bold mb-2">{article.title}</h2>
									<p className="text-sm text-gray-600">{article.description}</p>
								</div>
							</div>
						</Link>
					))}
				</div>
			</main>
			<Footer />
			<Outlet />
		</div>
	);
}
